export default class ArchivedEntityException extends Error {}
